{
  "appName": "Pulsar Anvil Studios",
  "dashboard": {
    "title": "Dashboard",
    "welcomeBack": "Welcome back"
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "wsDebug": "WebSocket Debug",
    "tools": "Tools"
  },
  "topbar": {
    "toggleSidebar": "Toggle sidebar",
    "toggleDarkMode": "Toggle dark mode",
    "userMenu": "User menu",
    "roles": "Roles: {{roles}}",
    "logout": "Logout"
  },
  "notFound": {
    "title": "Lost in the void",
    "message": "Looks like this page wandered off the map. Let's get you back on track.",
    "backToDashboard": "Back to Dashboard"
  }
}
